import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose } from 'recompose'
import * as routes from '../../../constants/routes'
import { withRouter } from 'react-router-dom'
import { TOGGLE_VIEW, SELECTED_CANIDATE } from '../../../constants/actionTypes'
//import moment from 'moment'
import { withStyles } from '@material-ui/core/styles';
//import Paper from '@material-ui/core/Paper';
//import Button from '@material-ui/core/Button'
//import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';  
import RequesterDetails from './AdminEventDetails/RequesterDetails';
import EventDetails from './AdminEventDetails/EventDetails'
import CanidateDetails from './AdminEventDetails/CanidateDetails'
import CanidateSelect from './AdminEventDetails/CanidateSelect'
import Headline from '../../../Container/Headlines/PageHeadline'
import {defaultGridSettings} from '../../../js/settings/grid'
import InAppNav from '../../InAppNav/InAppNav'

const styles = theme => ({
    
})


class AdminCanidateDetails extends Component {
/*
    constructor(props) {
        super(props);
    
        this.state = {
          selectedCanidate: null,
        };
    } */

    componentDidMount () {
        const { history, openEvent } = this.props

        if(typeof(openEvent)==='undefined')
        history.push(routes.ADMINEVENTS)
    }

    componentWillUnmount () {
       // this.props.onResetCanidate(null)
    }

    render() {
       const { openEvent } = this.props
       const headline = 'Hilfebedarf vermitteln'
       const subtext = null
        return (
            <div className={styles.root}>
            <Headline headline={headline} subtext={subtext}/>
            <InAppNav links={[{name:'Admin Home', route: routes.ADMINHOME}, {name:'Hilfegesuch vermitteln', route: routes.ADMINEVENTS}]} />
                <Grid container {...defaultGridSettings.container}>
                    <Grid item {...defaultGridSettings.item} >
                        <RequesterDetails /> 
                    </Grid>
                    <Grid item {...defaultGridSettings.item} >
                    {openEvent===undefined
                            ? null
                            :<EventDetails />
                        }
                   
                    </Grid>
                    <Grid item {...defaultGridSettings.item} >
                        <CanidateSelect />
                    </Grid>
                    <Grid item {...defaultGridSettings.item} >
                        <CanidateDetails />
                    </Grid>
                   
                </Grid>

            
            </div>
        )
    }
}

const mapStateToProps = (state) =>({
   // hiddenState: state.appState.hiddenState.AdminCanidateDetails,
    openEvent: state.adminCanidateState.currentOpenEvent.event

})

const mapDispatchToProps = (dispatch) => ({
    onToggleView: (payload)=>dispatch({type: TOGGLE_VIEW, payload}),
    onResetCanidate: (resetCanidate)=>dispatch({type: SELECTED_CANIDATE, payload: resetCanidate})
})



export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
    )   (AdminCanidateDetails)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/AdminEventDetails.js